import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import SummaryCalculator from './summarycalculator';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

// Load build data by build id and redirect to Summary page.
function BuildHelper({ buildId }) {
  //const navigate = useNavigate();
  const cookies = new Cookies();

  useEffect(() => {
    // Load build data if "build" param is passed.
    const loadPreBuildData = async (buildId) => {
      try {
        const summaryCalculator = new SummaryCalculator();
        summaryCalculator.reset(true);
		    sessionStorage.clear();
        const data = await summaryCalculator.loadVehicleDataByBuildId(buildId);
        if (data) {
          const { year, carline, trim, modelCode, optionCode, province } = data;

          if (province !== sessionStorage.getItem('province')) {
            // mdp7-pref
            console.log(`setting the mdp7-pref to p=${province}`);
            cookies.remove('mdp7-pref');
            cookies.set('mdp7-pref' ,`p=${province}`, {
              path: '/',
              encode: String
            });
            sessionStorage.setItem('province', province);
            window.location.reload();
          }

          const navigateUrl = `${window.origin}${window.location.pathname}#/${year}/${carline}/${trim}/${modelCode}/${optionCode}/summary`;
          window.location.href = navigateUrl;
          return false;
        }
        console.log('failed to retrieve vehicle data from build id ', buildId);
        const navigateUrl = `${window.origin}${window.location.pathname}#/`;
        window.location.href = navigateUrl;
        return false;
      } catch (err) {
        console.log(err);
      }
    }

    loadPreBuildData(buildId);
  }, [])

  return <div className="mz-spinner">LOADING ...</div>;
}

BuildHelper.propTypes = {
  buildId: PropTypes.string.isRequired
}

export default BuildHelper